import { Select } from 'antd'
import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'

const StyledSelect = styled(Select)`
  width: max-content;
  height: max-content;

  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked,
  .anticon.anticon-search,
  .anticon.anticon-check,
  .ant-select-selection-overflow-item.ant-select-selection-overflow-item-suffix {
    display: none !important;
  }
  .ant-select-arrow {
    display: block;
  }
  .ant-select-selection-overflow {
    gap: 0.5rem;
  }

  .ant-select-selector .ant-select-selection-item {
    background: transparent;
    border: 1px solid rgb(50, 73, 215);
    height: max-content;
    padding: 1px 10px;
    border-radius: 50px;
  }
  .ant-select-selection-item-content {
    font-size: 0.8rem;
    margin-right: 10px;
  }
  .ant-select-selector {
    display: flex;
    align-items: center;
    border-radius: 8px !important;
    justify-content: center;
    pointer-events: auto;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding-right: 15px;
    margin-top: -10px;
  }
`

const GlobalStyle = createGlobalStyle`
.multiple-filter .ant-select-item-option-state,.multiple-filter .ant-select-clear {
    display: none !important;
  }
 
  .multiple-filter .ant-select-selector:after {
    content: "" !important;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    width: 15px !important;
    height: 15px;
    background-image: url('');
    margin:0px !important;
    background-size: contain;
    background-repeat: no-repeat;
    visibility:visible !important;
  }
  

`
const MultiFilter = ({ jobRoleForm, handleChange, option }) => {
  return (
    <>
      <GlobalStyle />
      <StyledSelect
        mode="multiple"
        allowClear
        placeholder="Select Degree"
        onChange={handleChange}
        value={jobRoleForm}
        notFoundContent=""
        className="multiple-filter"
        maxTagCount={option === false ? '' : 2}
      >
        {option !== false &&
          jobRoleForm.slice(2).map((item,index) => {
            return <Option value={item} key={index + 'role'}>{item}</Option>
          })}
      </StyledSelect>
    </>
  )
}
export default MultiFilter
